// extracted by mini-css-extract-plugin
export default {"report":"report_report__DDmlZ","reportAttention":"report_reportAttention__q4gc9","reportTitle":"report_reportTitle__p+unG"};